/**
 * return or create an entry for the specified page.
 *
 * it's essential that the draftState is wrapped in immer, in order for
 * mutations to be properly applied, as this function will create new entries if
 * none exist for the requested page.
 */
function getPageEntryById(entry, pageId) {
  let page = entry.pages.find(it => it.id === pageId);
  if (!page) {
    page = {
      id: pageId,
      items: {},
      clones: [],
      drawings: [],
      lines: []
    };
    entry.pages.push(page);
  }
  return page;
}

export { getPageEntryById };
//# sourceMappingURL=get-page-by-id.js.map
